export const API_BASE_URL = process.env.REACT_APP_API_URL || 'https://api.termotrack.com/api';

export const slidingSessionConfig = {
  tokenKey: 'auth_token',
  userKey: 'current_user',
  refreshThreshold: 6 * 60 * 60,
  monitorInterval: 5 * 60 * 1000,
  autoRefresh: true,
  loginRoute: '/login'
};
